import { signal } from "@preact/signals-react";
import { ComponentConfig } from "./Constants";
import { Message } from "imagica-corekit/dist/base/api/chatCompletionTyped/ChatCompletionsTyped";
import { WebConfigStore } from "imagica-corekit/dist/cases/webconfig/WebConfigStore";
import { getIt } from "@uikit/getIt";

type ComponentKey = keyof typeof ComponentConfig;
type AddThinkFunction = (word: string) => void;
export class GenPreviewBloc {
  public visible = signal<boolean>(true);
  public outputs = signal<ComponentKey[]>([]);
  private addThink: AddThinkFunction;
  private cotTemplates: any[] = [];

  constructor(addThink: AddThinkFunction) {
    this.addThink = addThink;
    this.init();
  }

  async init() {
    const state = await getIt(WebConfigStore).get();
    this.cotTemplates = state.cot.examples;
  }

  changeVisible(show: boolean) {
    this.visible.value = show;
  }

  updateOutput(message: Message) {
    const regex = /<([^>]*)>/g;
    const matches = message.content.match(regex);
    if (matches) {
      this.outputs.value = matches.map((str: string) => str.replace(/<|>/g, "") as ComponentKey);
    }
  }

  clear() {
    if (this.outputs.value.length === 0) return;
    this.outputs.value = [];
  }

  makeRealApp() {
    const index = Math.floor(Math.random() * this.cotTemplates.length);
    const template = this.cotTemplates[index];
    if (template) {
      this.addThink(template.label);
    }
  }
}
